import React, { useEffect, useState } from 'react';
import {
  buildClipThumbnailUrl,
  fetchClipThumbnailObjectUrl,
  getCalendarClipThumbnailWidth,
} from './clipThumbnailCache';

export default function ClipThumbnail({
  fileStem,
  clipFilename,
  getFreshTokenRef,
  maxWidth = getCalendarClipThumbnailWidth(),
  alt = 'Video thumbnail',
  className = 'result-thumbnail-image',
  placeholderClassName = 'result-thumbnail-placeholder',
}) {
  const thumbnailUrl = buildClipThumbnailUrl(fileStem, clipFilename, maxWidth);
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!thumbnailUrl) {
      setSrc(null);
      return undefined;
    }

    let cancelled = false;

    async function load() {
      const objectUrl = await fetchClipThumbnailObjectUrl(
        thumbnailUrl,
        () => getFreshTokenRef.current(),
      );
      if (!cancelled) {
        setSrc(objectUrl);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [thumbnailUrl, getFreshTokenRef]);

  if (!src) {
    return (
      <div className={placeholderClassName}>
        <span>🎬</span>
      </div>
    );
  }

  return <img src={src} alt={alt} className={className} loading="lazy" />;
}
